import { render, staticRenderFns } from "./HourSlotListItem.vue?vue&type=template&id=0ff27ad9&scoped=true"
import script from "./HourSlotListItem.vue?vue&type=script&lang=js"
export * from "./HourSlotListItem.vue?vue&type=script&lang=js"
import style0 from "./HourSlotListItem.vue?vue&type=style&index=0&id=0ff27ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff27ad9",
  null
  
)

export default component.exports